import { TEMPLATE_NAMES } from '@/cms/constants/template-names'

import { AccoListerAcco } from '@/scopes/common/domain/acco-lister/types'
import {
  AccoListerResponseMapper,
  createAccoListerResponseMapper,
} from '@/scopes/common/infrastructure/acco-lister/accoListerResponseMapper'
import { createQueryStringSerializer, QueryStringSerializer } from '@/scopes/common/infrastructure/query-strings/queryStringSerializer'
import defaultFetch from 'isomorphic-unfetch'

interface GetAccoListerResultsAPIParams {
  contextItemId: string
  datasourceId: string
  Country?: string[]
  Region?: string[]
  City?: string[]
}

interface Dependencies {
  env: {
    NEXT_PUBLIC_API_BASE_URL: string
  }
  fetch: typeof defaultFetch
  queryStringSerializer: QueryStringSerializer<GetAccoListerResultsAPIParams>
  accoListerResponseMapper: AccoListerResponseMapper
  contextItemId: string
  datasourceId: string
  template: string
  deskId: string
}

export interface AccoListerApiClient {
  getAccoListerResults: () => Promise<AccoListerAcco[]>
}

export function createAccoListerApiClient(dependencies: Partial<Dependencies> = {}): AccoListerApiClient {
  const {
    env = {
      NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
    },
    fetch = defaultFetch,
    queryStringSerializer = createQueryStringSerializer(),
    accoListerResponseMapper = createAccoListerResponseMapper(),
    contextItemId = '',
    datasourceId = '',
    template = '',
    deskId = '',
  } = dependencies as Dependencies

  const fetchOptions: RequestInit = {
    referrerPolicy: 'no-referrer-when-downgrade',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
    },
  }

  async function getAccoListerResults() {
    const url = buildAPIUrl()

    const response = await fetch(url, fetchOptions)
    const data = await response.json()

    return accoListerResponseMapper.map(data)
  }

  function buildAPIUrl(): string {
    const filter = getFilter(template)
    const queryString = queryStringSerializer.serialize({
      contextItemId,
      datasourceId,
      ...(filter ? { [filter]: [deskId] } : {}),
    })

    return `${env.NEXT_PUBLIC_API_BASE_URL}/AccoListerApi/GetAccoListResponse?${queryString}`
  }

  return { getAccoListerResults }
}

const templateFilters: Record<string, string> = {
  [TEMPLATE_NAMES.CountryPage]: 'Country',
  [TEMPLATE_NAMES.RegionPage]: 'Region',
  [TEMPLATE_NAMES.CityPage]: 'City',
}

function getFilter(template: string): string {
  return templateFilters[template] || ''
}
